import { mapGetters } from 'vuex';

import HeaderNav from '@/components/@general/Header/HeaderNav/index.vue';
import HeaderPhones from '@/components/@general/Header/HeaderPhones/index.vue';
import HeaderSocial from '@/components/@general/Header/HeaderSocial/index.vue';
import HeaderLang from '@/components/@general/Header/HeaderLang/index.vue';

export default {
  name: 'HeaderSidebar',
  components: { HeaderLang, HeaderSocial, HeaderPhones, HeaderNav },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  watch: {},
  created() {},
  mounted() {},
  computed: {
    ...mapGetters({
      contacts: 'setting/variables'
    })
  },
  methods: {}
};
